import { mapGetters } from "vuex"
import { ErrorLogService } from "@/services/";
import { PartsStoreOrdersService } from "@/services/PartsStoreOrdersService";
import { ShoppingCartService } from "@/services";
import { sessionHelper } from "@/components/mixins/sessionHelper";
import { stringHelper } from "@/components/mixins/stringHelper";
import { formatDateTime } from "@/components/mixins/formatDateTime";
import { setTimeout } from "timers";

export const partsStoreOrderDetailsMixin = {
  mixins: [stringHelper, formatDateTime, sessionHelper],
  data: () => ({
    dataOrderId: Number,
    loadingOrderData: true,
    processingOrder: false,
    isSunbeltOrder: false,
    showSplitOptionsIndex: -1,
    showHistory: false,
    orderInfoColumns: [
      { key: "Customer", label: "Customer", sortable: false },
      { key: "CustomerPONumber", label: "Customer PO", sortable: false },
      { key: "ShipVia", label: "Ship Via", sortable: false },
      { key: "FreightTerms", label: "Freight Terms", sortable: false },
      { key: "Date", label: "Date", sortable: false },
      { key: "Status", label: "Status", sortable: false },
    ],
    orderStatusHistoryColumns: [
      { key: "Name", sortable: false },
      { key: "Status", sortable: false },
      { key: "Date", sortable: false },
    ],
    shippingOptions: [],
    partsStoreOrderDetailsDto: Object,
    editObject: {},
    orderInfoRow: [
      {
        DealerNetOrderNumber: "",
        CustomerName: "Customer",
        CustomerNumber: "CustomerNumber",
        PONumber: "PoNumber",
        ShipVia: "ShipVia",
        FreightTerms: "FreightTerms",
        CreatedDate: "CreatedDate",
        Status: "Status",
      },
    ],
    freightTermOptions: [
      { text: "Prepaid", value: 0 },
      { text: "Third Party", value: 1 },
      { text: "Collect", value: 2 },
    ],
    cancellationReasonOptions: [
      { text: "Lost Sale", value: 0 },
      { text: "Demo", value: 1 },
      { text: "Other", value: 2 },
    ],
    orderItemsColumns: [
      { key: "FulfillmentType", label: "Fulfillment", sortable: false },
      { key: "McfPartNumber", label: "Part", sortable: false },
      { key: "PartDescription", label: "Description", sortable: false },
      { key: "Stock", label: "Stock", sortable: false },
      { key: "Quantity", label: "Qty", sortable: false },
      { key: "DealerNetPrice", label: "Dealer Net Price", sortable: false, class: "price" },
      { key: "DealerNetTotal", label: "Dealer Net Total", sortable: false, class: "price" },
      { key: "ExtendedPriceTargetCurrency", label: "Customer Price", sortable: false, class: "price" },
      { key: "TotalTargetCurrency", label: "Customer Total", sortable: false, class: "price" },
    ],
    fullPartDetails: [],
    // show form edit by name
    showEditing: {
      BillingName: false,
      BillingAddressLine1: false,
      BillingAddressLine2: false,
      BillingCity: false,
      BillingState: false,
      BillingPostalCode: false,
      ShippingAddressLine1: false,
      ShippingAddressLine2: false,
      ShippingCity: false,
      ShippingState: false,
      ShippingPostalCode: false,
      ThirdPartyBillingAccountNumber: false,
      TrackingNumber: false,
      ShippingMethod: false,
      FreightTerm: false,
    },
    splitOrderItem: {
      OrderItemId: 0,
      PartNumber: "",
      DealerNetQuantity: 1,
      InventoryQuantity: 1,
    },
    labels: {},
    orderStatusHistory: Object,
    selectedFreightTerm: "",
    restrictedShippingWords: ["UPS", ":", "FEDEX"],
  }),
  computed: {
    ...mapGetters(["user", "hasPermission", "availableDealerCodes", "getContentItem", "cartSummary", "McfCostCenterId", "activeAccountId", "IsMcfe"]),
    getFulfillmentOptions() {

      if (this.partsStoreOrderDetailsDto?.DNFulfillmentOnly) {
        return [
          { text: "DealerNet", value: 1 },
          { text: "Cancelled", value: 3 }
        ];

      } else {
        return [
          { text: "DealerNet", value: 1 },
          { text: "Inventory", value: 2 },
          { text: "Cancelled", value: 3 },
          { text: "Split Item", value: 4 },
        ]

      }

    },
    subtotal() {
      return (
        this.partsStoreOrderDetailsDto.OrderTotalTargetCurrency -
        this.partsStoreOrderDetailsDto.SalesTaxTargetCurrency
      );
    },
    isOpen() {
      let status = this.partsStoreOrderDetailsDto.Status;
      return status === 1 || status === 6 || status === 7; // submitted, Pending Approval, Approved
    },
    isClosed() {
      let status = this.partsStoreOrderDetailsDto.Status;
      // Processed, Closed, Canceled, Denied
      return status === 2 || status === 4 || status === 5 || status === 8;
    },
    userIsOrderAdmin() {
      return this.hasPermission("IsNGaugeOrderAdmin");
    },
    hasAccessToFulfillmentAccount() {
      let accountCodes = this.availableDealerCodes;
      let fulfillmentAccount = accountCodes.find((x) => {
        return x.AccountId == this.partsStoreOrderDetailsDto.FulfillmentAccount.Id;
      });
      return fulfillmentAccount !== undefined;
    },
    showThirdPartyShippingWarning() {
      var showWarning = false;
      if (this.IsNotNullOrUndefined(this.partsStoreOrderDetailsDto.ThirdPartyBillingAccountNumber)) {
        showWarning = this.restrictedShippingWords.some(x => this.partsStoreOrderDetailsDto.ThirdPartyBillingAccountNumber.toUpperCase().includes(x));
      }
      return showWarning;
    },
    statusHistoryButtonText() {
      return this.showHistory ? "Hide Status History" : "Show Status History"
    },
  },
  methods: {
    async GetOrderDetailsDto() {
      return PartsStoreOrdersService.GetOrder(this.dataOrderId)
        .then((orderDto) => {
          this.loadingOrderData = false;

          // need to create a deep copy here so I can keep track of changes https://stackoverflow.com/q/7574054/
          let copy = JSON.parse(JSON.stringify(orderDto.data));
          this.editObject = copy;
          return (this.partsStoreOrderDetailsDto = orderDto.data);
        })
        .then(() => {
          // need to check if this is a sunbelt customer, so we can display the invoice message
          this.GetSmartEquipCustomer(this.partsStoreOrderDetailsDto.Customer.Id);
        })
        .then(() => {
          PartsStoreOrdersService.GetShippingOptions(
            this.partsStoreOrderDetailsDto.FulfillmentAccount.Id,
            this.partsStoreOrderDetailsDto.Customer.Id,
            false,
            this.user.UserId
          ).then((warehouseShippingOptionSelectionDto) => {
            let options = [];
            let i = 0;
            let length = warehouseShippingOptionSelectionDto.data.length;
            for (i; i < length; i++) {
              var option =
                warehouseShippingOptionSelectionDto.data[i].ShippingMethodCode +
                " - " +
                warehouseShippingOptionSelectionDto.data[i].ShippingMethodDescription;
              let optionObject = {
                text: option,
                value: option,
              };
              options.push(optionObject);
            }
            return (this.shippingOptions = options);
          });
        })
        .then(() => {
          PartsStoreOrdersService.GetOrderStatusHistory(
            this.partsStoreOrderDetailsDto.FulfillmentAccount.Id,
            this.user.UserId,
            this.dataOrderId
          ).then((orderStatusHistory) => {
            return (this.orderStatusHistory = orderStatusHistory.data);
          });
        })
        .catch((err) => {
          ErrorLogService.LogException(err);
          this.$store.commit("pushTimedMessage", {
            header: this.getContentItem("failedToRetrieveOrderInformation"),
            IsError: true,
            seconds: 20,
          });
        })
        .finally(() => {
          this.processingOrder = false;
        });
    },
    GetSmartEquipOrder() {
      PartsStoreOrdersService.GetSunbeltOrder(this.poNumber, this.customerId)
        .then((sunbeltOrderDto) => {
          this.isSunbeltOrder = true;
          this.dataOrderId = sunbeltOrderDto.data.Id;
        })
        .then(() => {
          this.GetOrderDetailsDto();
        });
    },
    GetSmartEquipCustomer(customerId) {
      PartsStoreOrdersService.GetSmartEquipCustomer(customerId).then((smartEquipCustomer) => {
        return (this.isSunbeltOrder = smartEquipCustomer.data !== null);
      });
    },
    ProcessOrder() {
      this.processingOrder = true;
      this.selectedFreightTerm = this.getFreightTermText(this.editObject.FreightTerm);
      this.setRecentComponentData()
      var params = {};
      var dealers = this.partsStoreOrderDetailsDto.FulfillmentAccount.AccountCodes;
      var primaryDealer = dealers.filter(x => x.IsPrimary)[0];
      var dealerCode = ""

      // clear out the current cart

      if (this.cartSummary.ItemCount > 0) {
        const shoppingCartParams = {
          mcfCostCenterId: this.McfCostCenterId,
          accountId: this.activeAccountId,
          userId: this.user.UserId,
          shoppingCartId: this.cartSummary.Id
        };

        ShoppingCartService.EmptyCart(shoppingCartParams);
      }

      if (primaryDealer) {
        dealerCode = primaryDealer.Code
      }
      else if (dealers[0]) {
        dealerCode = dealers[0].Code;
      }
      else {
        return;
      }
      params.dealerCode = dealerCode;
      params.isDn6 = window.appGlobals.IS_DN6;
      params.sessionVarString = this.getSessionVarString(this.user.UserId);
      params.refreshAfterProcessing = false;
      this.$store.dispatch("UPDATE_DEALER_CODE", params).then(updateResponse => {
        this.$store.commit("pushTimedMessage", {
          header: "Dealer code has been updated to match this order.",
          IsError: false,
          seconds: 20,
        });
        this.FinishProcessingOrder();
      })
    },
    FinishProcessingOrder() {
      return PartsStoreOrdersService.ProcessOrder(
        this.partsStoreOrderDetailsDto.FulfillmentAccount.Id,
        this.user.UserId,
        this.partsStoreOrderDetailsDto.Id,
        this.cartSummary.Id
      )
        .then((response) => {
          // check if we need to redirect
          if (response.data.QueryString) {
            // redirect to Cart
            this.$router.push({ name: 'ShoppingCart', query: { partsStoreOrderId: response.data.QueryString } });
          }
          // no DealerNet Items to Process, so just refresh the order on the page
          else {
            this.GetOrderDetailsDto();
          }
          return;
        })
        .catch((err) => {
          this.processingOrder = false;
          ErrorLogService.LogException(err);
          this.$store.commit("pushTimedMessage", {
            header: this.getContentItem("failedToProcessOrder"),
            IsError: true,
            seconds: 20,
          });
        });
    },
    resetRecentComponentData() {
      this.dataOrderId = this.orderId;
      this.GetOrderDetailsDto().then(() => {
        this.selectedFreightTerm = this.getFreightTermText(this.editObject.FreightTerm);
        this.setRecentComponentData();
      });
    },
    setRecentComponentData() {
      var componentData = {};
      componentData.freightTerm = this.selectedFreightTerm.replace(/\s/g, '');
      componentData.shippingMethod = this.editObject.ShippingMethod;
      componentData.shippingAddressLine1 = this.editObject.ShippingAddressLine1;
      componentData.shippingAddressLine2 = this.editObject.ShippingAddressLine2;
      componentData.shippingCity = this.editObject.ShippingCity;
      componentData.shippingCountry = this.editObject.ShippingCountry;
      componentData.shippingPostalCode = this.editObject.ShippingPostalCode;
      componentData.shippingState = this.editObject.ShippingState;
      componentData.fulfillmentAccountId = this.editObject.FulfillmentAccount.Id;
      componentData.partsStoreOrderId = this.editObject.Id;
      componentData.partsStoreCustomerNumber = this.partsStoreOrderDetailsDto.Customer.CustomerNumber;
      componentData.partsStoreOrderNumber = this.partsStoreOrderDetailsDto.OrderNumber;
      componentData.thirdPartyBillingAccountNumber = this.editObject.ThirdPartyBillingAccountNumber;
      componentData.shippingCompanyName = this.partsStoreOrderDetailsDto.Customer.Name;
      componentData.poNumber = this.editObject.PoNumber;

      this.$store.commit("SET_RECENT_COMPONENT", { name: "PartsStoreOrderDetails", data: componentData });
    },
    save() {
      PartsStoreOrdersService.UpdateOrder(
        this.partsStoreOrderDetailsDto.FulfillmentAccount.Id,
        this.user.UserId,
        this.editObject
      )
        .then(() => {
          this.GetOrderDetailsDto();
          this.$store.commit("pushTimedMessage", {
            header: this.getContentItem("orderHasBeenUpdatedSucessfully"),
            IsError: false,
            seconds: 20,
          });
        })
        .catch((err) => {
          ErrorLogService.LogException(err);
          this.$store.commit("pushTimedMessage", {
            header: this.getContentItem("failedToUpdateOrder"),
            IsError: true,
            seconds: 20,
          });
        });
    },
    updateOrderItemQuantity(orderItemId, quantity) {
      if (quantity < 0) {
        this.$store.commit("pushTimedMessage", {
          header: this.getContentItem("quantityMustBeGreaterThanZero"),
          IsError: true,
          seconds: 20,
        });

        this.GetOrderDetailsDto();

        return;
      }

      PartsStoreOrdersService.UpdateOrderItemQuantity(
        this.partsStoreOrderDetailsDto.FulfillmentAccount.Id,
        this.user.UserId,
        this.partsStoreOrderDetailsDto.Id,
        orderItemId,
        quantity
      )
        .then(() => {
          this.GetOrderDetailsDto();
          this.$store.commit("pushTimedMessage", {
            header: this.getContentItem("orderItemHasBeenUpdatedSuccessfully"),
            IsError: false,
            seconds: 20,
          });
        })
        .catch((err) => {
          ErrorLogService.LogException(err);
          this.$store.commit("pushTimedMessage", {
            header: this.getContentItem("failedToUpdateOrderItem"),
            IsError: true,
            seconds: 20,
          });
        });
    },
    updateFulfillment(orderItemId, fulfillmentType) {
      // if Split is selected, open the modal
      if (fulfillmentType === 4) {
        // revert change in case it was cancelled
        let items = this.partsStoreOrderDetailsDto.Items;
        let part = items.find((x) => {
          return x.Id === orderItemId;
        });

        // set modal values
        this.splitOrderItem.OrderItemId = orderItemId;
        this.splitOrderItem.PartNumber = part.McfPartNumber;
        this.splitOrderItem.DealerNetQuantity = part.Quantity > 1 ? part.Quantity - 1 : 1;
        this.splitOrderItem.InventoryQuantity = 1;

        let editItems = this.editObject.Items;
        let editPart = editItems.find((y) => {
          return y.Id === orderItemId;
        });

        // revert the type change in case it was cancelled
        part.FulfillmentType = editPart.FulfillmentType;
        return;
      }

      PartsStoreOrdersService.UpdateOrderItemFulfillment(
        this.partsStoreOrderDetailsDto.FulfillmentAccount.Id,
        this.user.UserId,
        this.partsStoreOrderDetailsDto.Id,
        orderItemId,
        fulfillmentType
      )
        .then(() => {
          this.GetOrderDetailsDto();
          this.$store.commit("pushTimedMessage", {
            header: this.getContentItem("orderItemFulfillmentUpdateSuccess"),
            IsError: false,
            seconds: 20,
          });
        })
        .catch((err) => {
          ErrorLogService.LogException(err);
          this.$store.commit("pushTimedMessage", {
            header: this.getContentItem("OrderItemUpdateFulfillmentFailure"),
            IsError: true,
            seconds: 20,
          });
        });
    },
    updateFulfillmentOnAllItems(fulfillmentType) {
      PartsStoreOrdersService.UpdateOrderItemFulfillmentOnAllItems(
        this.partsStoreOrderDetailsDto.FulfillmentAccount.Id,
        this.user.UserId,
        this.partsStoreOrderDetailsDto.Id,
        fulfillmentType
      )
        .then(() => {
          this.GetOrderDetailsDto();
          this.$store.commit("pushTimedMessage", {
            header: this.getContentItem("orderItemUpdateFulfillmentSuccess"),
            IsError: false,
            seconds: 20,
          });
        })
        .catch((err) => {
          ErrorLogService.LogException(err);
          this.$store.commit("pushTimedMessage", {
            header: this.getContentItem("OrderItemUpdateFulfillmentFailure"),
            IsError: true,
            seconds: 20,
          });
        });
    },
    splitItem(orderItemId, dealerNetQuantity, inventoryQuantity) {
      if (dealerNetQuantity < 0 || inventoryQuantity < 0) {
        this.$store.commit("pushTimedMessage", {
          header: this.getContentItem("orderItemSplitFailedValueQuantity"),
          IsError: true,
          seconds: 20,
        });
        return;
      }
      PartsStoreOrdersService.SplitOrderItem(
        this.partsStoreOrderDetailsDto.FulfillmentAccount.Id,
        this.user.UserId,
        this.partsStoreOrderDetailsDto.Id,
        orderItemId,
        dealerNetQuantity,
        inventoryQuantity
      )
        .then(() => {
          this.GetOrderDetailsDto();
          this.$store.commit("pushTimedMessage", {
            header: this.getContentItem("orderItemSplitSuccess"),
            IsError: false,
            seconds: 20,
          });
        })
        .catch((err) => {
          ErrorLogService.LogException(err);
          this.$store.commit("pushTimedMessage", {
            header: this.getContentItem("orderItemSplitFailed"),
            IsError: true,
            seconds: 20,
          });
        });
      this.showSplitOptionsIndex = -1;
    },
    DealerNetPrice(partId, quantity) {
      let items = this.partsStoreOrderDetailsDto.Items;
      let part = items.find((obj) => {
        return obj.PartId === partId;
      });
      return part.DealerNetPriceTargetCurrency * quantity;
    },
    getStatusText(statusId) {
      switch (statusId) {
        case 0:
          return "NotSet";
        case 1:
          return "Submitted";
        case 2:
          return "Processed";
        case 3:
          return "Shipped";
        case 4:
          return "Closed";
        case 5:
          return "Canceled";
        case 6:
          return "Pending Approval";
        case 7:
          return "Approved";
        case 8:
          return "Denied";
      }
    },
    getFreightTermText(termId) {
      let freightTermOptions = this.freightTermOptions;
      let freightTerm = freightTermOptions.find((obj) => {
        return obj.value === termId;
      });

      return freightTerm.text;
    },
    getFulfillmentText(typeId) {
      let fulfillmentOptions = this.getFulfillmentOptions;
      let fulfillmentType = fulfillmentOptions.find((obj) => {
        return obj.value === typeId;
      });

      return fulfillmentType.text;
    },
    getOrderStatusReasonText(orderStatusReasonId) {
      if (orderStatusReasonId === null) {
        return "";
      }
      let reasons = this.cancellationReasonOptions;
      let cancellationReason = reasons.find((obj) => {
        return obj.value === orderStatusReasonId;
      });

      return cancellationReason?.text;
    },
    printOrder() {
      window.print();
    },
    toggleShowEditing(key, isSave) {
      if (typeof isSave === "undefined") {
        isSave = false;
      }
      // flip the editing flag
      this.showEditing[key] = !this.showEditing[key];
      if (this.showEditing[key] && this.$refs[key]) {
        // close any other open edits
        let keysByIndex = Object.keys(this.showEditing);
        for (let i = 0; i < keysByIndex.length; i++) {
          if (keysByIndex[i] !== key) {
            this.showEditing[keysByIndex[i]] = false;
          }
        }

        // setting timeout to give the input time to appear
        setTimeout(() => {
          this.$refs[key].focus();
          this.$refs[key].select();
        });
      }
      // revert any changes
      else if (!isSave) {
        this.editObject[key] = this.partsStoreOrderDetailsDto[key];
      }
    },
  }
};